import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Slot intake control (Audit -> Slot Control): store-level, per-date PICKUP-slot block.
// Reads Admin_GetSlotBlackout (slots + live pickup load + blocked flag) and toggles via
// Admin_SetSlotBlackout. Enforcement is server-side in the pickup-booking proc (pickup-only;
// deliveries unaffected).
export default class SlotControlService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  async getStores(isRetry) {
    const api = new API({ url: this.config.DROPDOWN_URL });
    api.createEntity({ name: this.endpoint.GET_STORE });
    let out = {};
    await api.endpoints[this.endpoint.GET_STORE]
      .getAll()
      .then((r) => { out = r.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const r = await this.common.refreshToken();
        this.common.setToken(r);
        return await this.getStores(true);
      } catch (e) { return { statusCode: 401 }; }
    }
    return out;
  }

  // date = "YYYY-MM-DD"
  async getBlackout(storeId, date, isRetry) {
    const api = new API({ url: this.config.ITEM_URL });
    api.createEntity({ name: this.endpoint.GET_SLOT_BLACKOUT });
    let out = {};
    await api.endpoints[this.endpoint.GET_SLOT_BLACKOUT]
      .getAll({ params: { StoreID: storeId, BlockDate: date } })
      .then((r) => { out = r.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const r = await this.common.refreshToken();
        this.common.setToken(r);
        return await this.getBlackout(storeId, date, true);
      } catch (e) { return { statusCode: 401 }; }
    }
    return out;
  }

  async setBlackout(storeId, date, slotId, block, isRetry) {
    const api = new API({ url: this.config.ITEM_URL });
    api.createEntity({ name: this.endpoint.SET_SLOT_BLACKOUT });
    let out = {};
    await api.endpoints[this.endpoint.SET_SLOT_BLACKOUT]
      .getAllPost({ StoreID: storeId, BlockDate: date, SlotID: slotId, Block: block })
      .then((r) => { out = r.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const r = await this.common.refreshToken();
        this.common.setToken(r);
        return await this.setBlackout(storeId, date, slotId, block, true);
      } catch (e) { return { statusCode: 401 }; }
    }
    return out;
  }

  // capacity = integer limit, or null/0 to clear (unlimited)
  async setCapacity(storeId, slotId, capacity, isRetry) {
    const api = new API({ url: this.config.ITEM_URL });
    api.createEntity({ name: this.endpoint.SET_SLOT_CAPACITY });
    let out = {};
    await api.endpoints[this.endpoint.SET_SLOT_CAPACITY]
      .getAllPost({ StoreID: storeId, SlotID: slotId, Capacity: capacity })
      .then((r) => { out = r.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const r = await this.common.refreshToken();
        this.common.setToken(r);
        return await this.setCapacity(storeId, slotId, capacity, true);
      } catch (e) { return { statusCode: 401 }; }
    }
    return out;
  }
}
